module.exports = __webpack_public_path__ + "img/mobile-menu-action-icon.ec8596db.svg";